import { KDSPrimengThemeColorTokens } from '../models/primeng-theme-preset.model';

export const KDSPrimengColorTokens: Readonly<KDSPrimengThemeColorTokens> = {
  mask: {
    background: 'var(--modal-overlay-background)',
  },
  kds: {
    filterTagRemoveIconColor: 'var(--icon-primary)',
    filterTagTextColor: 'var(--text-primary)',
    filterTagBackground: 'var(--tag-filter)',

    tagsInputPlaceholderColor: 'var(--text-secondary)',
    tagsInputHoverBorderColor: 'var(--input-border-hover)',
    tagsInputFocusBorderColor: 'var(--input-border-focused)',
    tagsInputBorderColor: 'var(--border-primary)',
    tagsInputInvalidBorderColor: 'var(--border-danger)',

    checkboxBackground: 'var(--background-primary)',
    checkboxBorderColor: 'var(--border-checkboxradio)',
    checkboxBorderHoverColor: 'var(--input-border-hover)',
    checkboxBorderFocusColor: 'var(--input-border-focused)',
    checkboxCheckedBackground: 'var(--button-primary-background-default)',
    checkboxCheckedBorderColor: 'var(--button-primary-background-default)',
    checkboxCheckedHoverBackground: 'var(--button-primary-background-hover)',
    checkboxCheckedHoverBorderColor: 'var(--button-primary-background-hover)',
    checkboxCheckedIconColor: 'var(--global-white)',
    checkboxDisabledBackground: 'var(--input-background-disabled)',
    checkboxDisabledBorderColor: 'var(--border-disabled)',
    checkboxCheckedDisabledBackground: 'var(--border-disabled)',
    checkboxCheckedDisabledBorderColor: 'var(--border-disabled)',

    dialogBackground: 'var(--modal-background)',
    dialogShadow: 'var(--shadow-lg)',

    datatableHeaderCellColor: 'var(--text-primary)',
    datatableHeaderCellBackground: 'var(--background-primary)',
    datatableHeaderCellSelectedBackground: 'var(--background-primary)',
    datatableHeaderCellHoverBackground: 'var(--background-primary)',
    datatableHeaderBorderColor: 'var(--border-primary)',

    datatableBodyCellBorderColor: 'var(--border-primary)',
    datatableRowBackground: 'var(--background-primary)',
    datatableRowHoverBackground: 'var(--background-hover)',

    selectOverlayBackground: 'var(--background-primary)',
    selectOverlayBorderColor: 'var(--border-primary)',
    selectOverlayColor: 'var(--text-primary)',
    selectOverlayShadow: 'var(--shadow-s)',

    selectOptionColor: 'var(--text-primary)',
    selectOptionSelectedBackground: 'var(--background-selected-default)',
    selectOptionSelectedColor: 'var(--text-primary)',
    selectOptionSelectedFocusBackground: 'var(--background-selected-default)',
    selectOptionFocusBackground: 'transparent',
    selectOptionHoverBackground: 'var(--background-hover)',
    selectOptionGroupColor: 'var(--text-secondary)',
    selectOptionGroupBackground: 'transparent',

    selectLabelColor: 'var(--text-primary)',
    selectPlaceholderColor: 'var(--text-secondary)',
    selectDropdownColor: 'var(--icon-primary)',
    selectDisabledLabelColor: 'var(--text-disabled)',
    selectDisabledDropdownColor: 'var(--icon-disabled)',
    selectClearIconColor: 'var(--icon-primary)',
    cascadeselectOptionGroupIconColor: 'var(--icon-secondary)',
  },
};
